import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../../core/contexts/AuthContext';
import { SIDEBAR_WIDTH } from './AppSidebar';
import { useNavigate, useLocation } from 'react-router-dom';

const TOP_TABS = [
  { label: 'Tenants', pathPrefix: '/' },
  { label: 'Global Settings', pathPrefix: '/global-settings' },
  { label: 'Prompt Monitoring', pathPrefix: '/prompt-monitoring' },
  { label: 'Job Monitoring', pathPrefix: '/job-monitoring' },
  { label: 'AI Chat Monitoring', pathPrefix: '/ai-chat-monitoring' },
];

function useTopTab() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/global-settings')) return 1;
  if (pathname.startsWith('/prompt-monitoring')) return 2;
  if (pathname.startsWith('/job-monitoring')) return 3;
  if (pathname.startsWith('/ai-chat-monitoring')) return 4;
  return 0;
}

export function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const tab = useTopTab();
  const initial = user?.name?.[0] ?? user?.email?.[0] ?? '?';

  const handleTab = (_: React.SyntheticEvent, value: number) => {
    if (value === 0) navigate('/');
    else if (value === 1) navigate('/global-settings/document-management');
    else if (value === 2) navigate('/prompt-monitoring');
    else if (value === 3) navigate('/job-monitoring');
    else navigate('/ai-chat-monitoring');
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (t) => t.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar sx={{ pl: 3 }}>
        <Box sx={{ width: SIDEBAR_WIDTH - 24, mr: 3 }}>
          <Typography variant="h6" color="primary" lineHeight={1.1}>
            Bootstrap
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Backoffice
          </Typography>
        </Box>

        {/* Top-level section tabs */}
        <Tabs
          value={tab}
          onChange={handleTab}
          sx={{ height: 64, '& .MuiTabs-indicator': { bottom: 0 } }}
          TabIndicatorProps={{ style: { height: 3 } }}
        >
          {TOP_TABS.map((t) => (
            <Tab
              key={t.label}
              label={t.label}
              sx={{ fontWeight: 600, minHeight: 64, textTransform: 'none', fontSize: 14 }}
            />
          ))}
        </Tabs>

        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" spacing={2} alignItems="center">
          <Box sx={{ textAlign: 'right' }}>
            <Typography variant="body2" fontWeight={600}>
              {user?.name ?? user?.email}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {user?.role}
            </Typography>
          </Box>
          <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main' }}>
            {initial.toUpperCase()}
          </Avatar>
          <Tooltip title="Sign out">
            <IconButton onClick={logout} size="small">
              <LogoutIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
